export const SDK_VERSION = '8.9.2';
